import { render, staticRenderFns } from "./CommonFormItem.vue?vue&type=template&id=bafcb48a&"
import script from "./CommonFormItem.vue?vue&type=script&lang=js&"
export * from "./CommonFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports